import React from 'react';
import { Form, Section, EmptyState, Icon } from '@weezevent/nacre';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

export default function IframeToURL({ value, onChange }) {
    const { t } = useTranslation();

    const [textValue, setTextValue] = React.useState(null);
    const [finalValue, setFinalValue] = React.useState(null);
    const [error, setError] = React.useState(false);

    React.useEffect(() => {
        parseValue(value);
    }, [value]);

    const parseValue = React.useCallback(value => {
        setTextValue(value);
        setError(false);
        if (value) {
            // URL like: https://www.youtube.com/embed/M4qHXoAyrRs
            let matchYoutube = value.match(/https:\/\/www\.youtube\.com\/embed\/([a-zA-Z0-9-_]+)/i);
            // URL like: https://www.youtube.com/watch?v=M4qHXoAyrRs
            let matchYoutubeDirect = value.match(/https:\/\/www\.youtube\.com\/watch\?v=([a-zA-Z0-9-_]+)/i);
            // URL like: https://www.dailymotion.com/embed/video/M4qHXoAyrRs
            let matchDailymotion = value.match(/https:\/\/www\.dailymotion\.com\/embed\/video\/([a-zA-Z0-9-_]+)/i);

            if (matchYoutubeDirect) {
                const finalURL = `https://www.youtube.com/embed/${matchYoutubeDirect[1]}`;
                setFinalValue(finalURL);
                onChange(finalURL);
            } else if (matchYoutube) {
                setFinalValue(matchYoutube[0]);
                onChange(matchYoutube[0]);
            } else if (matchDailymotion) {
                setFinalValue(matchDailymotion[0]);
                onChange(matchDailymotion[0]);
            } else {
                setFinalValue(null);
                setError(true);
                onChange(null);
            }
        } else {
            setFinalValue(null);
            onChange(null);
        }
    }, []);

    return (
        <div>
            <Form.Field>
                <Form.Label>{t('ticket.form.modal.customFields.iframeLabel')}</Form.Label>
                <Form.Sublabel>{t('ticket.form.modal.customFields.iframeSublabel')}</Form.Sublabel>
                <Form.Input
                    placeholder={t('ticket.form.modal.customFields.iframePlaceholder')}
                    onChange={({ target: { value } }) => {
                        parseValue(value);
                    }}
                    value={textValue}
                />
            </Form.Field>
            <Section>
                <Form.Field>
                    <Form.Label>{t('ticket.form.modal.customFields.urlLabel')}</Form.Label>
                </Form.Field>
                {!error && finalValue ? (
                    <div>
                        <iframe title="Iframe Preview" width="100%" height="315" src={finalValue} className="iframe_resize" frameBorder="0" allowFullScreen></iframe>
                    </div>
                ) : (
                    <EmptyState
                        icon={<Icon name="video" />}
                        title={t(`ticket.form.modal.customFields.urlPreview.${error && value ? 'error' : 'empty'}-title`)}
                        subtitle={t(`ticket.form.modal.customFields.urlPreview.${error && value ? 'error' : 'empty'}-subtitle`)}
                    />
                )}
            </Section>
        </div>
    );
}

IframeToURL.propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string
};

IframeToURL.defaultProps = {
    value: ''
};
